import { getCurrentBaskets } from "routes/schedule/plugins/baskets/tree/baskets-tree.runtime"

export function findBasket(parentId) {
    let basket = null
    for (const baskets of Object.values(getCurrentBaskets())) {
        basket ??= baskets?.[parentId]
    }
    return basket
}
